import {GetAllContactSettingUrl,UpdateAbortAlarmTime, UpdateOfflineDurationUrl ,UpdateRegistrationHeaderUrl,UpdateRegistrationTextUrl,
    UpdateAboutAppUrl,UpdateContactUrl,UpdateSupportUrl,UpdateFeedbackUrl, UpdateDistanceForArrivedDetectionUrl, 
    updateAutoApprovedUserUrl, updateAutoApprovedUserTimeUrl, setDefaultAlarmDistanceUrl, setDefaultEquipmentDistanceUrl,
    autoDefaultEquipmentDistanceUrl, updateEquipmentConditionUrl,UpdateLifeguardDefibrillatorCprText,
    UpdateUserRegistrationRequest,UpdateUserRegistrationRequestTime
      } from '../../Comman/apiEndPoints';
import varAxios from "../../Comman/axios";

export const Fetch_Offline_Duration_Setting_Data = "Fetch_OFFLINE_DURATION_SETTING_DATA";
export const Update_Offline_Duration_Setting_Success = "Update_OFFLINE_DURATION_SETTING_SUCCESS";
export const Update_Registration_Header_Setting_Success = "Update_REGISTRATION_HEADER_SETTING_SUCCESS";
export const Update_Registration_Text_Setting_Success = "Update_REGISTRATION_TEXT_SETTING_SUCCESS";
export const Fetch_Request = "Fetch_Request";
export const Update_Setting_Success = "Update_Setting_Success";

export const Fetch_UpdateLifeguardDefibrillatorCprText= "Fetch_UpdateLifeguardDefibrillatorCprText";
export const Update_UpdateLifeguardDefibrillatorCprText= "Update_UpdateLifeguardDefibrillatorCprText";
export const Update_UpdateAbortAlarmTime= "Update_UpdateAbortAlarmTime";

export function getAllOfflineDuration() {
    return(dispatch) =>{
       return varAxios.get(GetAllContactSettingUrl)
       .then(response => {
          dispatch(
            fetchAllOfflineDurationSettingsData({
                errorCode : response.data.errorCode,
                statusCode : response.data.statusCode,
                allSetting : response.data.GlobalSettings
             }));
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchAllOfflineDurationSettingsData({errorCode, statusCode, allSetting}) {
    return {
      type : Fetch_Offline_Duration_Setting_Data,
      errorCode,
      statusCode,
      allSetting
    }
}

export function updateOfflineDuration(value) {
  let data = {
    SettingValue : value
  }
  return (dispatch) => {
    dispatch(fetchRequest())
      return varAxios.post(UpdateOfflineDurationUrl, data,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
            if(response.data.statusCode == 200){
              dispatch(
                updateOfflineDurationDataSuccess(response.data.errorCode,response.data.statusCode,
                  response.data.Message,response.data.Value)
              );
            }
          })
          .catch((error) => {
              console.log(error)
          })
  }
} 

export function updateOfflineDurationDataSuccess(errorCode,statusCode,message,updatedValue) {
  return {
    type : Update_Offline_Duration_Setting_Success,
    errorCode,
    statusCode,
    message,
    updatedValue
  }
}
 
export function updateRegistrationHeader(value) {
  let data = {
    SettingValue : value
  }
  return (dispatch) => {
    dispatch(fetchRequest())
      return varAxios.post(UpdateRegistrationHeaderUrl, data,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
            if(response.data.statusCode == 200){
              dispatch(
                updateRegistrationHeaderSuccess(response.data.errorCode,response.data.statusCode,
                  response.data.Message,response.data.Value)
              );
            }
          })
          .catch((error) => {
              console.log(error)
          })
  }
} 

export function updateRegistrationHeaderSuccess(errorCode,statusCode,message,updatedValue) {
  return {
    type : Update_Registration_Header_Setting_Success,
    errorCode,
    statusCode,
    message,
    updatedValue
  }
}


export function updateRegistrationText(value) {
  let data = {
    SettingValue : value
  }
  return (dispatch) => {
    dispatch(fetchRequest())
      return varAxios.post(UpdateRegistrationTextUrl, data,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
            if(response.data.statusCode == 200){
              dispatch(
                updateRegistrationTextSuccess(response.data.errorCode,response.data.statusCode,
                  response.data.Message,response.data.Value)
              );
            }
          })
          .catch((error) => {
              console.log(error)
          })
  }
} 

export function updateRegistrationTextSuccess(errorCode,statusCode,message,updatedValue) {
  return {
    type : Update_Registration_Text_Setting_Success,
    errorCode,
    statusCode,
    message,
    updatedValue
  }
}
export function fetchRequest(){
  return{
    type: Fetch_Request
  }
}
export function UpdateAboutApp(value) {
  let data = {
    SettingValue : value
  }
  return (dispatch) => {
    dispatch(fetchRequest())
      return varAxios.post(UpdateAboutAppUrl, data,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
            if(response.data.statusCode == 200){
              dispatch(
                UpdateSettingSuccess(response.data.errorCode,response.data.statusCode,
                  response.data.Message,response.data.Value)
              );
            }
          })
          .catch((error) => {
              console.log(error)
          })
  }
}
export function UpdateContact(value) {
  let data = {
    SettingValue : value
  }
  return (dispatch) => {
    dispatch(fetchRequest())
      return varAxios.post(UpdateContactUrl, data,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
            if(response.data.statusCode == 200){
              dispatch(
                UpdateSettingSuccess(response.data.errorCode,response.data.statusCode,
                  response.data.Message,response.data.Value)
              );
            }
          })
          .catch((error) => {
              console.log(error)
          })
  }
}
export function UpdateSupport(value) {
  let data = {
    SettingValue : value
  }
  return (dispatch) => {
    dispatch(fetchRequest())
      return varAxios.post(UpdateSupportUrl, data,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
            if(response.data.statusCode == 200){
              dispatch(
                UpdateSettingSuccess(response.data.errorCode,response.data.statusCode,
                  response.data.Message,response.data.Value)
              );
            }
          })
          .catch((error) => {
              console.log(error)
          })
  }
}
export function UpdateFeedback(value) {
  let data = {
    SettingValue : value
  }
  return (dispatch) => {
    dispatch(fetchRequest())
      return varAxios.post(UpdateFeedbackUrl, data,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
            if(response.data.statusCode == 200){
              dispatch(
                UpdateSettingSuccess(response.data.errorCode,response.data.statusCode,
                  response.data.Message,response.data.Value)
              );
            }
          })
          .catch((error) => {
              console.log(error)
          })
  }
}
export function UpdateSettingSuccess(errorCode,statusCode,message,responseValue) {
  return{
    type : Update_Setting_Success,
    errorCode,
    statusCode,
    message,
    responseValue
  }
}
export function updateDistance(value) {
  let data = {
    SettingValue : value
  }
  return (dispatch) => {
      return varAxios.post(UpdateDistanceForArrivedDetectionUrl, data,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
            if(response.data.statusCode == 200){
              dispatch(
                UpdateSettingSuccess(response.data.errorCode,response.data.statusCode,
                  response.data.Message,response.data.Value)
              );
            }
          })
          .catch((error) => {
              console.log(error)
          })
  }
}

export function updateAutoApprovedUser(value) {
  let data = {
    SettingValue : value
  }
  return (dispatch) => {
      return varAxios.post(updateAutoApprovedUserUrl, data,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
            if(response.data.statusCode == 200){
              dispatch(
                UpdateSettingSuccess(response.data.errorCode,response.data.statusCode,
                  response.data.Message,response.data.Value)
              );
            }
          })
          .catch((error) => {
              console.log(error)
          })
  }
}

export function updateAutoApprovedUserTimeFunc(value) {
  let data = {
    SettingValue : value
  }
  return (dispatch) => {
      return varAxios.post(updateAutoApprovedUserTimeUrl, data,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
            if(response.data.statusCode == 200){
              dispatch(
                UpdateSettingSuccess(response.data.errorCode,response.data.statusCode,
                  response.data.Message,response.data.Value)
              );
            }
          })
          .catch((error) => {
              console.log(error)
          })
  }
}
export function updateAutoApprovedUser1(value) {
  let data = {
    SettingValue : value
  }
  return (dispatch) => {
      return varAxios.post(UpdateUserRegistrationRequest, data,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
            if(response.data.statusCode == 200){
              dispatch(
                UpdateSettingSuccess(response.data.errorCode,response.data.statusCode,
                  response.data.Message,response.data.Value)
              );
            }
          })
          .catch((error) => {
              console.log(error)
          })
  }
}

export function updateAutoApprovedUserTimeFunc1(value) {
  let data = {
    SettingValue : value
  }
  return (dispatch) => {
      return varAxios.post(UpdateUserRegistrationRequestTime, data,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
            if(response.data.statusCode == 200){
              dispatch(
                UpdateSettingSuccess(response.data.errorCode,response.data.statusCode,
                  response.data.Message,response.data.Value)
              );
            }
          })
          .catch((error) => {
              console.log(error)
          })
  }
}
export function setDefaultAlarmDistanceFunc(value) {
  let data = {
    SettingValue : value
  }
  return (dispatch) => {
      return varAxios.post(setDefaultAlarmDistanceUrl, data,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
            if(response.data.statusCode == 200){
              dispatch(
                UpdateSettingSuccess(response.data.errorCode,response.data.statusCode,
                  response.data.Message,response.data.Value)
              );
            }
          })
          .catch((error) => {
              console.log(error)
          })
  }
}

export function setDefaultEquipmentDistanceFunc(value) {
  let data = {
    SettingValue : value
  }
  return (dispatch) => {
      return varAxios.post(setDefaultEquipmentDistanceUrl, data,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
            if(response.data.statusCode == 200){
              dispatch(
                UpdateSettingSuccess(response.data.errorCode,response.data.statusCode,
                  response.data.Message,'')
              );
            }
          })
          .catch((error) => {
              console.log(error)
          })
  }
}

export function autoDefaultEquipmentDistanceFunc(value) {
  let data = {
    SettingValue : value
  }
  return (dispatch) => {
      return varAxios.post(autoDefaultEquipmentDistanceUrl, data,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
            if(response.data.statusCode == 200){
              dispatch(
                UpdateSettingSuccess(response.data.errorCode,response.data.statusCode,
                  response.data.Message,response.data.Value)
              );
            }
          })
          .catch((error) => {
              console.log(error)
          })
  }
}
export function updateEquipmentConditionFunc(value) {
  // let data = {
  //   SettingValue : value
  // }
  return (dispatch) => {
      return varAxios.post(updateEquipmentConditionUrl, value,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
            if(response.data.statusCode == 200){
              dispatch(
                UpdateSettingSuccess(response.data.errorCode,response.data.statusCode,
                  response.data.Message,'')
              );
            }
          })
          .catch((error) => {
              console.log(error)
          })
  }


}
  export function UpdateLifeguardDefibrillatorCprText1(value) {
  
  return (dispatch) => {
    dispatch(fetchRequest())
      return varAxios.post(UpdateLifeguardDefibrillatorCprText, value,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
            if(response.data.statusCode == 200){
              dispatch(
                UpdateLifeguardDefibrillatorCprTextSuccess(response.data.errorCode,response.data.statusCode,
                  response.data.Message,response.data.Value)
              );
            }
          })
          .catch((error) => {
              console.log(error)
          })
  }
} 

export function UpdateLifeguardDefibrillatorCprTextSuccess(errorCode,statusCode,message,updatedValue) {
  return {
    type : Update_UpdateLifeguardDefibrillatorCprText,
    errorCode,
    statusCode,
    message,
    updatedValue
  }
}
  export function UpdateAbortAlarmTime1(value) {
  
  return (dispatch) => {
    dispatch(fetchRequest())
      return varAxios.post(UpdateAbortAlarmTime, value,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
            if(response.data.statusCode == 200){
              dispatch(
                UpdateAbortAlarmTimeSuccess(response.data.errorCode,response.data.statusCode,
                  response.data.Message,response.data.Value)
              );
            }
          })
          .catch((error) => {
              console.log(error)
          })
  }
} 

export function UpdateAbortAlarmTimeSuccess(errorCode,statusCode,message,updatedValue) {
  return {
    type : Update_UpdateAbortAlarmTime,
    errorCode,
    statusCode,
    message,
    updatedValue
  }
}